module.exports = __webpack_public_path__ + "img/RED_BERRIES.6a844b51.png";